// extracted by mini-css-extract-plugin
export var billingAddress = "_xc-g";
export var contactInfo = "_xc-d";
export var customerInfoContainer = "_xc-c";
export var customerInfoContainerMobile = "_xc-h";
export var customerInfoRow = "_xc-a";
export var customerInfoSection = "_xc-b";
export var fullWidthDividerMobile = "_xc-i";
export var imageContainer = "_xc-1";
export var paymentMethod = "_xc-e";
export var priceText = "_xc-6";
export var priceTextMobile = "_xc-7";
export var product = "_xc-0";
export var productImage = "_xc-2";
export var productInfo = "_xc-4";
export var productMobile = "_xc-9";
export var productTitle = "_xc-8";
export var quantityBadge = "_xc-3";
export var quantityText = "_xc-5";
export var shippingAddress = "_xc-f";